module.exports = __webpack_public_path__ + "assets/img/zhibo.0b6961d0.png";